import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import {
    ProductMaterialCategoryBody,
    ProductMaterialCategoryListItem,
} from "types/api/productMaterialCategory";

function useProductMaterialCategoryApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllProductMaterialCategory = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<ProductMaterialCategoryListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<ProductMaterialCategoryListItem>>({
            url: "/product-material-category",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createProductMaterialCategory = React.useCallback((body: ProductMaterialCategoryBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, ProductMaterialCategoryBody, ResponseWithId>({
            url: "/product-material-category",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateProductMaterialCategory = React.useCallback((pathParams: PathParamsWithId, body: ProductMaterialCategoryBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, ProductMaterialCategoryBody, null>({
            url: "/product-material-category/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteProductMaterialCategory = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/product-material-category/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllProductMaterialCategory,
        createProductMaterialCategory,
        updateProductMaterialCategory,
        deleteProductMaterialCategory
    };
}

export default useProductMaterialCategoryApi;